import state from './state.js'
export default {
	setUserToken(state, token) {
		state.setToken(token)
	},
	SET_TOKEN(state, token) {
		state.token = token;
	},
	SET_TAB_CHANGE(state, value) {
		state.isTabChange = value;
	}
}